import { useGLTF } from '@react-three/drei';
import type { Euler, Vector3 } from '@react-three/fiber';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import * as THREE from 'three';
import type { GLTF } from 'three-stdlib';

type GLTFResult = GLTF & {
  nodes: {
    dragon: THREE.Mesh;
  };
};
interface DragonProps {
  color?: string;
  position?: Vector3;
  scale?: Vector3;
  rotation?: Euler;
}

const Dragon = ({ color, position, rotation, scale }: DragonProps): ReactElement => {
  const { nodes } = useGLTF('/assets/3d/Dragon-draco.glb') as unknown as GLTFResult;

  const group = useRef<THREE.Group>(null);
  const refModel = useRef(null);
  const material = new THREE.MeshPhongMaterial({
    color: color || '#030303',
    shininess: 7,
  });
  // const [diff, disp, norm, spec] = useTexture([
  //   '/assets/3d/textures/stone/2K-stone-diffuse.jpg',
  //   '/assets/3d/textures/stone/2K-stone-displacement.jpg',
  //   '/assets/3d/textures/stone/2K-stone-normal.jpg',
  //   '/assets/3d/textures/stone/2K-stone-specular.jpg',
  // ]);

  // const material = new THREE.MeshPhysicalMaterial({
  //   color: color || '#070707',
  //   map: diff,
  //   normalMap: norm,
  //   specularIntensityMap: spec,
  // });

  return (
    <group ref={group} position={position} rotation={rotation} scale={scale} dispose={null}>
      <mesh
        ref={refModel}
        geometry={nodes.dragon.geometry}
        material={material}
        position={[0, 0, 0]}
        scale={[0.5, 0.5, 0.5]}
        rotation={[0, 0, 0]}
        castShadow
      />
      <meshStandardMaterial color="#003300" attach="material" />
    </group>
  );
};

// useGLTF.preload('/assets/3d/Dragon-draco.glb');

export default Dragon;
